import { render, staticRenderFns } from "./CommboxConversationsPage.vue?vue&type=template&id=4fbd794a&scoped=true&"
import script from "./CommboxConversationsPage.vue?vue&type=script&lang=js&"
export * from "./CommboxConversationsPage.vue?vue&type=script&lang=js&"
import style0 from "./CommboxConversationsPage.vue?vue&type=style&index=0&id=4fbd794a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbd794a",
  null
  
)

export default component.exports